// Shared severity styles for alert components (AlertsPage, Header dropdown, etc.)
export const SEVERITY_STYLES = {
  critical: { dot: 'bg-red-500 animate-pulse', badge: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300', label: 'CRITICAL' },
  high: { dot: 'bg-red-500', badge: 'bg-red-50 text-red-700 dark:bg-red-900/20 dark:text-red-300', label: 'HIGH' },
  medium: { dot: 'bg-amber-500', badge: 'bg-amber-50 text-amber-700 dark:bg-amber-900/20 dark:text-amber-300', label: 'MEDIUM' },
  low: { dot: 'bg-blue-400', badge: 'bg-blue-50 text-blue-700 dark:bg-blue-900/20 dark:text-blue-300', label: 'LOW' },
};
